export default __webpack_public_path__ + "static/media/roulette-mobile.d7ad49e0.png";